import { type FC, type ReactNode } from 'react'
import { type ITypographyProps, Typography } from 'shared/ui'
import styles from './styles.module.scss'

type ILearnMoreLinkProps = {
  href: string
  children: ReactNode
  typographyProps?: ITypographyProps
  onClick?: () => void
}

export const LearnMoreLink: FC<ILearnMoreLinkProps> = ({
  href,
  children,
  typographyProps,
  onClick,
}) => {
  return (
    <a
      href={href}
      target='_blank'
      rel='noreferrer'
      className={styles.learnMoreLink}
      onClick={onClick}
    >
      <Typography
        ariaLabel='TermsAndPrivacy_link'
        variant='body-md-medium'
        color='var(--content-brand-primary)'
        className={styles.learnMoreLink}
        {...typographyProps}
      >
        {children}
      </Typography>
    </a>
  )
}
